import { render, staticRenderFns } from "./disMan.vue?vue&type=template&id=321b56cb&scoped=true&"
import script from "./disMan.vue?vue&type=script&lang=js&"
export * from "./disMan.vue?vue&type=script&lang=js&"
import style0 from "./disMan.vue?vue&type=style&index=0&id=321b56cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b56cb",
  null
  
)

export default component.exports